import _ from 'lodash';
import moment from 'moment';
import ConstantsStorage from '../../constants/index';
import {initialSocket} from '../models/socket-model';

const ACTIONS = ConstantsStorage().SOCKET_ACTIONS;

export default (state = initialSocket(), action) => {
  let newState;
  switch (action.type) {
  case ACTIONS.UPDATE:
    newState = _.cloneDeep(state);

    if (action.key) {
      const newObject = {};
      newObject[action.key] = action.data;
      return {...newState, ...newObject};
    }

    return {...newState, ...action.data};

  case ACTIONS.MESSAGE_RECEIVED_TYPING:
    newState = _.cloneDeep(state);
    return {...newState, someoneIsTyping: true, someoneTypedTime: Date.now()};

  case ACTIONS.TOOGLE_ANYONE_TYPING:
    if (state.someoneTypedTime && moment(state.someoneTypedTime).add(action.interval, 'ms').isAfter(Date.now())) {
      newState = _.cloneDeep(state);
      return {...newState, someoneIsTyping: false};
    }
    return state;

  case ACTIONS.MESSAGE_RECEIVED:
    newState = _.cloneDeep(state);
    return {...newState, messages: [...newState.messages, action.payload]};
  default:
    return state;
  }
};
